export default __webpack_public_path__ + "static/media/video.da693e1d.jpg";